import { useState } from 'react'
import { useWindowSize } from '../../../../../core/hooks/common/useWindowSize'
import { TABLET_SIZE } from '../../../../../core/constants/common'
import {
    CacheKeys,
    fiatAccountsOptions,
} from '../../../../../core/constants/filter'
import FilterLayout from '../../../../layout/filter/FilterLayout'
import { useGetAllAccounts } from '../../../../../core/services/react-query/report/due-payments'
import FiatAccountTable from './FiatAccountTable'
import RFiatAccountTable from './RFiatAccountTable'

const FiatAccounts = () => {
    const { width } = useWindowSize()
    const [accounts, setAccounts] = useState({ data: null, loading: true })


    const onQuerySuccess = (res) => {
        setAccounts(res)
    }

    const Component = width > TABLET_SIZE ? FiatAccountTable : RFiatAccountTable

    return (
        <FilterLayout
            query={useGetAllAccounts}
            onQuerySuccess={onQuerySuccess}
            options={fiatAccountsOptions}
            cache={CacheKeys.FIAT_ACCOUNTS}
        >
            {width && <Component data={accounts} />}
        </FilterLayout>
    )
}

export default FiatAccounts
